import HTTP from "../../../services/HTTP.js";
// fetch projects
export const getProjects = async (paramsOptions) => {
  const { page, limit, search, statusFilter, sortBy, sortOrder } =
    paramsOptions || {};
  const res = await HTTP.get("/projects", {
    params: {
      page,
      limit,
      search,
      status: statusFilter,
      sortBy,
      sortOrder,
    },
  });
  return res.data;
};

export const getProjectById = async (id) => {
  const res = await HTTP.get(`/projects/${id}`);
  return res.data;
};

// fetch project id associtate data
export const getAssocitateDataByProjectId = async (id, paramsOptions) => {
  const { currentPage, limit, search, statusFilter, sortBy, sortOrder } =
    paramsOptions || {};
  const res = await HTTP.get(`projects/projectId/${id}`, {
    params: {
      page: currentPage + 1,
      limit,
      search,
      status: statusFilter,
      sortBy,
      sortOrder,
    },
  });
  return res.data;
};

// fetch project history by id
export const getProjectHistoryById = async (paramsOptions) => {
  const { projectId, page, limit } = paramsOptions || {};
  const res = await HTTP.get(`projects/history/${projectId}`, {
    params: {
      page,
      limit,
    },
  });
  return res.data;
};

// add Project
export const addProject = async (data) => {
  const res = await HTTP.post("projects/add", data);
  return res.data;
};

// update project
export const updateProject = async (data) => {
  const res = await HTTP.put("projects/update", data);
  return res.data;
};
// delete project
export const deleteProject = async (id) => {
  const res = await HTTP.delete(`projects/delete/${id}`);
  return res.data;
};
